import React, { useMemo } from 'react';
import styled from 'styled-components';
import { FinishScreenProps } from '../../types';
import { calculateHighestCategory } from '../../utils/calculateHighestCategory';

const FinishContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 1rem;
  gap: 3.2rem;
`;

const Result = styled.div`
  background-color: rgba(212, 175, 55, 0.08);
  color: var(--color-darkest);
  border-radius: 10px;
  text-align: center;
  padding: 3rem 3.6rem;
  font-size: 2rem;
  font-weight: 500;
  margin-bottom: 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  border: 1px solid rgba(212, 175, 55, 0.3);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  max-width: 90%;
`;

const Emoji = styled.span`
  display: block;
  font-size: 5rem;
  margin-bottom: 1.6rem;
  line-height: 1;
`;

const ResultTitle = styled.h3`
  font-family: var(--font-secondary);
  font-size: 2.8rem;
  font-weight: 500;
  color: var(--color-theme);
  margin-bottom: 0.8rem;
`;

const ResultDescription = styled.p`
  font-family: var(--font-secondary);
  font-size: 1.8rem;
  line-height: 1.6;
  color: var(--color-darkest);
`;

const FinishScreen: React.FC<FinishScreenProps> = ({ categoryCounts, answers, questions, resultsSubmitted, onRestart }) => {
  // Memoize the highest category calculation to prevent unnecessary re-renders
  const highestCategory = useMemo(() => {
    return calculateHighestCategory(categoryCounts);
  }, [categoryCounts]);

  // Determine personality type based on highest category
  let personalityType = '';
  let description = '';
  let emoji = '';

    // Otherwise, determine personality type based on highest category
  switch (highestCategory.category) {
    case 'A':
      personalityType = 'Old Money';
      description = 'Preferujete nadčasové, kvalitné šperky, ktoré vyjadrujú Váš zmysel pre tradíciu a eleganciu.';
      emoji = '✨';
      break;
    case 'B':
      personalityType = 'Jednoduchá nadčasovosť';
      description = 'Uprednostňujete jednoduché, funkčné šperky, ktoré sa hodia ku všetkému a nevyžadujú veľa pozornosti.';
      emoji = '💎';
      break;
    case 'C':
      personalityType = 'Hojnosť - okázalý štýl';
      description = 'Milujete šperky, ktoré priťahujú pozornosť a umožňujú Vám vyjadriť svoju osobnosť a náladu.';
      emoji = '🌟';
      break;
    case 'D':
      personalityType = 'Dizajnová ikona';
      description = 'Hľadáte originálne, umelecké kúsky, ktoré sú jedinečné a vyjadrujú vašu tvorivú osobnosť.';
      emoji = '🎨';
      break;
    case 'E':
      personalityType = 'Štýlová variabilnosť';
      description = 'Máte rada rôzne štýly šperkov v závislosti od príležitosti a nálady.';
      emoji = '🔄';
      break;
    default:
      personalityType = 'Štýlová variabilnosť';
      description = 'Máte rada rôzne štýly šperkov v závislosti od príležitosti a nálady.';
      emoji = '🔄';
  }

  return (
    <FinishContainer>
      <Result>
        <Emoji onDoubleClick={onRestart}>{emoji}</Emoji>
        <ResultTitle>{personalityType}</ResultTitle>
        <ResultDescription>{description}</ResultDescription>
      </Result>

      <p style={{ fontSize: '2rem', textAlign: 'center'}}>
        Dúfame, že sme Vám urobili radosť! 😍
      </p>

      <p style={{ fontSize: '2rem', textAlign: 'center'}}>
        Podrobné vyhodnotenie Vám bolo zaslané na emailovú adresu.
      </p>
    </FinishContainer>
  );
};

export default FinishScreen;
